import { LifeglovHand, LifeglovSize, PatientLifeglov } from '@bioliberty/lifemind';
import { tms } from './tms';

interface AddPatientLifeglovParams {
  patientId: number;
  size?: LifeglovSize;
  hand?: LifeglovHand;
}

const patientLifeglov = tms.injectEndpoints({
  endpoints: (builder) => ({
    addPatientLifeglov: builder.mutation<PatientLifeglov, AddPatientLifeglovParams>({
      query: (newPatientLifeglov) => ({
        url: `patients/${newPatientLifeglov.patientId}/lifeglovs`,
        method: 'POST',
        body: {
          ...newPatientLifeglov
        }
      }),
      invalidatesTags: ['PatientLifeglov']
    }),
    getLatestPatientLifeglov: builder.query<PatientLifeglov, string>({
      query: (patientId) => ({
        url: `patients/${patientId}/lifeglovs/latest`,
        method: 'GET'
      }),
      providesTags: (_result, _error, patientId) => [{ type: 'PatientLifeglov', id: patientId }]
    })
  }),
  overrideExisting: false
});

export const { useMutation: useAddPatientLifeglovMutation } = patientLifeglov.endpoints.addPatientLifeglov;
export const { useQuery: useGetLatestPatientLifeglovQuery } = patientLifeglov.endpoints.getLatestPatientLifeglov;
